import React from 'react';
import { useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

const PanelBadgeRules = () => {
  const badges = useSelector((state) => {
    return state.scoring.badges
  }
);

  return (
    <div>
      <Typography variant="h4">Level Rules</Typography>
      {badges && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Badge</TableCell>
                <TableCell>Score</TableCell>
                <TableCell>Categories</TableCell>
                <TableCell>Id</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {badges?.map((badge) => (
                <TableRow key={badge.badge}>
                  <TableCell>{badge.badge}</TableCell>
                  <TableCell>{badge.score}</TableCell>
                  <TableCell>{badge.categories || 'N/A'}</TableCell>
                  <TableCell>{badge.id}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default PanelBadgeRules;

